export default __webpack_public_path__ + "static/media/Photo 7 - BR - ouverture est.c6cf84b0.png";